export default {    
  computed: {
    dropdownAccordionConfig() {
      let dropdownAccordionConfig = [
        {
          questionNumber: 1,
          questionDropdownData: [
            {
              title: "Cabeza",
              dropdowns: [
                {optionTitle: "Prenda", optionsList: this.headGarmentList, optionsName: "dataHeadGarment"},
                {optionTitle: "Estilo ", optionsList: this.headStyleList, optionsName: "dataHeadStyle"},
                {optionTitle: "Color", optionsList: this.headColorList, optionsName: "dataHeadColor"},
              ]
            },
            {
              title: "Cuerpo Superior",
              dropdowns: [
                {optionTitle: "Prenda", optionsList: this.sBodyGarmentList, optionsName: "dataSBodyGarment"},
                {optionTitle: "Mangas ", optionsList: this.sBodySleevesList, optionsName: "dataSBodySleeves"},
                {optionTitle: "Estilo", optionsList: this.sBodyStyleList, optionsName: "dataSBodyStyle"},
                {optionTitle: "Color", optionsList: this.sBodyColorList, optionsName: "dataSBodyColor"},
              ]
            },
            {
              title: "Cuerpo Inferior",
              dropdowns: [
                {optionTitle: "Prenda", optionsList: this.iBodyGarmentList, optionsName: "dataIBodyGarment"},
                {optionTitle: "Estilo", optionsList: this.iBodyStyleList, optionsName: "dataIBodyStyle"},
                {optionTitle: "Color", optionsList: this.iBodyColorList, optionsName: "dataIBodyColor"},
              ]
            },
            {
              title: "Pies",
              dropdowns: [
                {optionTitle: "Calzado", optionsList: this.feetFootwearList, optionsName: "dataFeetFootwear"},
                {optionTitle: "Estilo", optionsList: this.feetStyleList, optionsName: "dataFeetStyle"},
                {optionTitle: "Color", optionsList: this.feetColorList, optionsName: "dataFeetColor"},
              ]
            }
          ]
        },
        {
          questionNumber: 2,
          questionDropdownData: [
            {
              dropdowns: [
                {optionTitle: "Longitud", optionsList: this.hairLengthList, optionsName: "dataHairLength"},
                {optionTitle: "Tipo ", optionsList: this.hairTypeList, optionsName: "dataHairType"},
                {optionTitle: "Color", optionsList: this.hairColorList, optionsName: "dataHairColor"},
              ]
            },
          ]
        },
        {
          questionNumber: 3,
          questionDropdownData: [
            {
              dropdowns: [
                {optionTitle: "Sexo", optionsList: this.genderList, optionsName: "dataGender"},
                {optionTitle: "Estatura ", optionsList: this.heightList, optionsName: "dataHeight"},
                {optionTitle: "Volumen", optionsList: this.volumeList, optionsName: "dataVolume", optionLabel: "male"},
              ]
            },
          ]
        },
        {
          questionNumber: 4,
          questionDropdownData: [
            {
              dropdowns: [
                {optionTitle: "Edad", optionsList: this.stageOfLifeList, optionsName: "dataStageOfLife"},
              ]
            },
          ]
        },
        {
          questionNumber: 5,
          questionDropdownData: [
            {
              title: "Cabeza",
              dropdowns: [
                {optionTitle: "Parte", optionsList: this.headPartList, optionsName: "dataHeadPart"},
                {optionTitle: "Zona ", optionsList: this.headZoneList, optionsName: "dataHeadZone"},
                {optionTitle: "Tipo", optionsList: this.headTypeList, optionsName: "dataHeadType"},
              ]
            },
            {
              title: "Cuerpo",
              dropdowns: [
                {optionTitle: "Parte", optionsList: this.bodyPartList, optionsName: "dataBodyPart"},
                {optionTitle: "Zona", optionsList: this.bodyZoneList, optionsName: "dataBodyZone"},
                {optionTitle: "Tipo", optionsList: this.bodyTypeList, optionsName: "dataBodyType"},
              ]
            },
            {
              title: "Brazo",
              dropdowns: [
                {optionTitle: "Parte", optionsList: this.armPartList, optionsName: "dataArmPart"},
                {optionTitle: "Lado", optionsList: this.armSideList, optionsName: "dataArmSide"},
                {optionTitle: "Zona", optionsList: this.armZoneList, optionsName: "dataArmZone"},
                {optionTitle: "Tipo", optionsList: this.armTypeList, optionsName: "dataArmType"},
              ]
            },
            {
              title: "Pierna",
              dropdowns: [
                {optionTitle: "Parte", optionsList: this.legPartList, optionsName: "dataLegPart"},
                {optionTitle: "Lado", optionsList: this.legSideList, optionsName: "dataLegSide"},
                {optionTitle: "Zona", optionsList: this.legZoneList, optionsName: "dataLegZone"},
                {optionTitle: "Tipo", optionsList: this.legTypeList, optionsName: "dataLegType"},
              ]
            }
          ]
        },
        {
          questionNumber: 8,
          questionDropdownData: [
            {
              dropdowns: [
                {optionTitle: "Accesorio", optionsList: this.accessoryList, optionsName: "dataAccessory"},
                {optionTitle: "Parte", optionsList: this.partList, optionsName: "dataPart"},
                {optionTitle: "Zona", optionsList: this.zoneList, optionsName: "dataZone"},
                {optionTitle: "Color", optionsList: this.colorList, optionsName: "dataColor"},
              ]
            },
          ]
        },
        {
          questionNumber: 9,
          questionDropdownData: [
            {
              dropdowns: [
                {
                  optionTitle: "Movilidad", 
                  optionsList: this.mobilityList, optionsName: "dataMobility",
                  updateOtherDropdown: [
                    {
                      "Marca": {
                        "A pie": [],
                        "Bicicleta": this.brandBikeList,
                        "Motocicleta": this.brandMotorcycleList,
                        "Automovil": this.brandCarList,
                      }
                    },
                    {
                      "Tipo": {
                        "A pie": [],
                        "Bicicleta": this.typeBikeList,
                        "Motocicleta": this.typeMotorcycleList,
                        "Automovil": this.typeCarList,
                      }
                    },
                    {
                      "Color": {
                        "A pie": [],
                        "Bicicleta": this.colorList,
                        "Motocicleta": this.colorList,
                        "Automovil": this.colorList,
                      }
                    }
                  ]
                },
                {optionTitle: "Marca", optionsName: "dataMobilityType", dynamicOptions: true},
                {optionTitle: "Tipo", optionsName: "dataMobilityType", dynamicOptions: true},
                {optionTitle: "Color", optionsName: "dataMobilityColor", dynamicOptions: true},
              ]
            },
          ]
        },
        {
          questionNumber: 10,
          questionDropdownData: [
            {
              dropdowns: [
                {
                  optionTitle: "Tipo", 
                  optionsList: this.typeOfWeaponList, optionsName: "dataTypeOfWeapon", 
                  updateOtherDropdown: [
                    {
                      "Elemento": {
                        "Arma blanca": this.whiteWeaponList,
                        "Arma de fuego": this.fireWeaponList,
                        "Objeto": this.objectWeaponList,
                      }
                    }
                  ]
                },
                {optionTitle: "Elemento", optionsName: "dataWeaponElement", dynamicOptions: true},
                {optionTitle: "Color", optionsList: this.weaponColorList, optionsName: "dataWeaponColor"},
              ]
            },
          ]
        },
      ]
      return dropdownAccordionConfig;
    },
    inputsTextConfig(){
      const inputsTextConfig = [
        {
          questionNumber: 3,
          inputData: { title: "Estatura aproximada en cm", inputName: "dataApproximateHeight" }
        },
        {
          questionNumber: 4,
          inputData: { title: "Edad aproximada", inputName: "dataApproximateAge" }
        },
        {
          questionNumber: 10,
          inputData: { title: "Calibre", inputName: "dataWeaponCaliber" }
        },
        
      ]
      return inputsTextConfig;
    },
    buttonsAnswer() {
      const buttonsAnswer = [
        {
          id: 1,
          icon: "pi pi-undo",
          aditionalClasses: "p-button-info",
          color: "#A956F7",
          tooltip: "Deshacer cambio",
          disabled: (slotProps) => !this.canRevert(slotProps?.option?.questionNumber),
          action: (event, slotProps) => this.revertAnswer(event , slotProps.option.questionNumber)
        },
        {
          id: 2,
          icon: "pi pi-pencil",
          aditionalClasses: "p-button-info",
          color: "#FFA800",
          tooltip: "Editar respuesta",
          disabled: () => { return false },
          action: (event, slotProps) => this.editAnswer(event, slotProps.option.questionNumber)
        },
        {
          id: 3,
          icon: "pi pi-trash",
          aditionalClasses: "p-button-danger",
          color: "",
          tooltip: "Eliminar respuesta",
          disabled: () => { return false },
          action: (event, slotProps) => this.confirmDelete(event, slotProps.option)
        }
      ]
      return buttonsAnswer;
    }
  },
};